/**
 * Identity rules shared with the gateway (src/utils/validation.ts there).
 *
 * A username is also the chat identity `username@company_domain`, and the chat
 * server splits that on "@" — so an e-mail address can never be a username.
 * Letters, digits, ".", "-" and "_" are all fine.
 */
export const USERNAME_RE = /^[a-zA-Z0-9][a-zA-Z0-9._-]{1,39}$/;

/** Any script's letters (Turkish included), spaces, apostrophes, dots and dashes. */
export const DISPLAY_NAME_RE = /^\p{L}[\p{L}\p{M}.'-]*(?: \p{L}[\p{L}\p{M}.'-]*)*$/u;
